export enum DocumentRole {
  Author = 'Author',
  Editor = 'Editor'
}

export enum ShareType {
  Send = 'Send',
  ShareAccess = 'ShareAccess'
}

export interface DocumentParticipant {
  id: string;
  knowledgeItemId?: string;
  userId: string;
  username: string;    // Изменено с userName на username для соответствия API
  fullName: string;    // Изменено с userFullName на fullName для соответствия API
  role: DocumentRole;
  createdAt: string;
}

export interface ShareDocumentRequest {
  recipientUsername: string;
  knowledgeItemId: string;
  shareType: ShareType;
  text?: string;
}

export interface DocumentActivityLog {
  id: string;
  knowledgeItemId: string;
  userId: string;
  userName: string;
  action: string;
  details?: string;
  timestamp: string;
}

export interface DocumentParticipantsResponse {
  participants: DocumentParticipant[];
  isAuthor: boolean;
  currentUserRole?: DocumentRole;
} 